module.exports = __webpack_public_path__ + "static/media/DEFAULT_MEDIUM_IMAGE_3.9dacc55c.gif";